/*
 * KAS LUXURY — two things the product page was missing, both copied from a competitor
 * who sells far more than we do.
 *
 * Benchmarked against traxnyc.com on 9 Oct 2026. They are a Shopify store too, so none
 * of this was a platform advantage -- it was all choices they made and we had not.
 *
 * ONE — THE PRICE OF EVERY SIZE, ON THE SIZE ITSELF.
 * Their chain pages put the price on each length button: 20 in, 22 in, 24 in, each with
 * its own figure, under the line "the price follows the length". Ours hid the pricing
 * band and showed a single figure that moved after the customer chose, which reads as a
 * surprise even when the number is correct. Same mechanism, opposite feeling.
 *
 * THE TRAP THIS FILE FELL INTO ONCE, SO NOBODY FALLS IN AGAIN:
 * the theme renders these options as <option>{{ option }}</option>, with NO value
 * attribute. An option with no value attribute takes its value from its own text. So
 * writing a price into the label silently rewrote the VALUE too, and the size that went
 * onto the order became "US 9 - $1,320" instead of "US 9". The fix is the two lines
 * marked PIN below: give the option an explicit value attribute BEFORE touching its
 * text, after which the label and the value are independent. Verified on the live page:
 * labels carry the price, values stay clean.
 *
 * TWO — A WAY TO REACH A HUMAN FROM THE PIECE ITSELF.
 * Their page has "Text a jeweler about this piece" and a phone number beside the buy
 * button. Ours had a floating chat bubble that says nothing about what you are looking
 * at. This adds a WhatsApp link that opens with the piece's name already written.
 *
 * NO BACKSLASHES IN THIS FILE -- see the note in kas-ring-size.js.
 */
(function () {
  'use strict';

  var SIZE_LABEL = 'Ring size (US)';
  var BAND_NAME = 'options[Size band]';
  var WHATSAPP = '66943101506';
  var NUMBER = /([0-9]+(?:[.][0-9]+)?)/;
  var RANGE = /([0-9]+(?:[.][0-9]+)?)[ ]*[-–—][ ]*([0-9]+(?:[.][0-9]+)?)/;
  var CLEAN = 'data-kas-clean-label';

  function num(v) {
    var m = String(v).match(NUMBER);
    return m ? parseFloat(m[1]) : null;
  }

  function findSelect(name) {
    var all = document.querySelectorAll('select');
    for (var i = 0; i < all.length; i++) {
      if (all[i].name === name) return all[i];
    }
    return null;
  }

  function money(cents, currency) {
    var n = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency || 'USD', maximumFractionDigits: 0
      }).format(n);
    } catch (e) {
      return '$' + Math.round(n);
    }
  }

  function currencyCode(product) {
    if (product && product.currency) return product.currency;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return 'USD';
  }

  // ---------------------------------------------------------------- one: price per size
  function priceTheSizes(product) {
    var sizeSelect = findSelect(SIZE_LABEL);
    var bandSelect = findSelect(BAND_NAME);
    if (!sizeSelect || !bandSelect || !product || !product.variants) return;

    var bands = [];
    for (var i = 0; i < bandSelect.options.length; i++) {
      var m = String(bandSelect.options[i].value).match(RANGE);
      if (m) {
        bands.push({
          value: bandSelect.options[i].value,
          lo: parseFloat(m[1]),
          hi: parseFloat(m[2])
        });
      }
    }
    if (!bands.length) return;

    var colour = (findSelect('options[Color]') || {}).value;
    var metal = (findSelect('options[Metal]') || {}).value;

    function priceFor(bandValue) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var opts = v.options || [];
        if (opts.indexOf(bandValue) === -1) continue;
        if (metal && opts.indexOf(metal) === -1) continue;
        if (colour && opts.indexOf(colour) === -1) continue;
        return v.price;
      }
      return null;
    }

    for (var j = 0; j < sizeSelect.options.length; j++) {
      var opt = sizeSelect.options[j];

      var base = opt.getAttribute(CLEAN);
      if (base === null) {
        base = opt.value;                       // the clean size, before any decoration
        opt.setAttribute(CLEAN, base);
        opt.setAttribute('value', base);        // PIN -- see the note at the top of
        opt.value = base;                       // PIN    this file. Must happen first.
      }

      var size = num(base);
      if (size === null) {
        opt.textContent = base;                 // "Choose your size" stays plain
        continue;
      }

      var band = null;
      for (var k = 0; k < bands.length; k++) {
        if (size >= bands[k].lo && size <= bands[k].hi) { band = bands[k].value; break; }
      }
      if (!band) {
        band = size < bands[0].lo ? bands[0].value : bands[bands.length - 1].value;
      }

      var cents = priceFor(band);
      opt.textContent = cents === null ? base
                                       : base + '  -  ' + money(cents, currencyCode(product));
    }
  }

  // ---------------------------------------------------------------- two: reach a human
  function addJewellerLink(product) {
    if (document.getElementById('kas-ask-jeweller')) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || !product) return;

    var name = (product.title || '').split('—')[0].trim() || product.title || 'a piece';
    var msg = 'Hello, I have a question about ' + name +
              ' (' + window.location.href.split('?')[0] + ')';

    var wrap = document.createElement('div');
    wrap.id = 'kas-ask-jeweller';
    wrap.className = 'kas-ask-jeweller';

    var a = document.createElement('a');
    a.href = 'https://api.whatsapp.com/send?phone=' + WHATSAPP +
             '&text=' + encodeURIComponent(msg);
    a.target = '_blank';
    a.rel = 'noopener';
    a.className = 'kas-ask-jeweller__link';
    a.textContent = 'Message a jeweller about this piece';

    var small = document.createElement('span');
    small.className = 'kas-ask-jeweller__note';
    small.textContent = 'Or call +66 94 310 1506. Someone at the bench answers, 9am to 7pm Bangkok time.';

    wrap.appendChild(a);
    wrap.appendChild(small);
    form.parentNode.insertBefore(wrap, form.nextSibling);
  }

  // ---------------------------------------------------------------- wiring
  function start() {
    var m = window.location.pathname.match(/[/]products[/]([^/?#]+)/);
    if (!m) return;
    fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product) return;
        addJewellerLink(product);
        priceTheSizes(product);
        document.addEventListener('change', function (e) {
          if (!e.target || e.target.tagName !== 'SELECT') return;
          if (e.target.name === SIZE_LABEL) return;
          setTimeout(function () { priceTheSizes(product); }, 60);
        }, true);
      })
      .catch(function () { /* a decorated label is a nicety; never break the page for it */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());